export const actions = {
	API_REQUEST: "API_REQUEST"
};
export const apiRequest = (request, onSuccess, onError, context = null, options) => ({
	type: actions.API_REQUEST,
	meta: { request, onSuccess, onError, context, options }
});
